import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Button from '../../../components/button';
import CustomModal from '../../../components/CustomModal';
import Input from '../../../components/input';
import Select from '../../../components/Select';
import { updateCategoryAsync, fetchCategories, getCategoriesOverview } from '../../../store/Slices/CategorySlice';
import { categoryValidationSchema } from '../../../utils/Schema';
import { categoryStatusOptions, categoryTypeOptions } from '../../../utils/Dropdowns';
import { errorNotify, successNotify } from '../../../utils/toast';

const UpdateCategoryModal = ({ show, onHide, category, currentPage, limit }) => {
    const dispatch = useDispatch();
    const { updateCategoryLoading } = useSelector((state) => state.categories);

    const initialValues = {
        title: category?.title || '',
        status: category?.status || 'active',
        type: category?.type || 'part'
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = {
                id: category.id,
                ...values
            };
            await dispatch(updateCategoryAsync(payload)).unwrap();
            successNotify('Category updated successfully');
            onHide();
            
            // Refresh table and overview
            dispatch(fetchCategories({
                page: currentPage,
                limit: limit,
                body: {}
            }));
            dispatch(getCategoriesOverview());
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <CustomModal heading="Update Category" size="lg" show={show} handleClose={onHide}>
            <Formik
                initialValues={initialValues}
                validationSchema={categoryValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="add_user_modal">
                            <h5>Category Information</h5>
                            <div>
                                <Input
                                    label="Title"
                                    placeholder="Enter category title"
                                    type="text"
                                    name="title"
                                    value={values.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.title}
                                    touched={touched.title}
                                />
                            </div>

                            <h5>Status and Type</h5>
                            <div>
                                <Select
                                    label="Type"
                                    placeholder="Select category type"
                                    options={categoryTypeOptions}
                                    name="type"
                                    value={categoryTypeOptions.find(opt => opt.value === values.type)}
                                    onChange={(option) => setFieldValue('type', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.type}
                                    touched={touched.type}
                                />
                                <Select
                                    label="Status"
                                    placeholder="Select category status"
                                    options={categoryStatusOptions}
                                    name="status"
                                    value={categoryStatusOptions.find(opt => opt.value === values.status)}
                                    onChange={(option) => setFieldValue('status', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.status}
                                    touched={touched.status}
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2" style={{ marginTop: "40px" }}>
                                <Button
                                    submitBtn={() => {}}
                                    loading={updateCategoryLoading || isSubmitting}
                                    disabled={updateCategoryLoading || isSubmitting}
                                    submitText="Update"
                                    type="submit"
                                    shouldRow={false}
                                    isShowSubmitBtn={true}
                                    isShowCancel={false}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </CustomModal>
    );
};

export default UpdateCategoryModal;
